import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

export interface DashboardStatsDto {
    totalOrders: number;
    totalRevenue: number;
    newOrdersToday: number;
    totalCustomers: number;
}

@Injectable()
export class DashboardService {
    private http = inject(HttpClient);
    private apiUrl = environment.apiUrl + '/Dashboard';

    getStats(): Observable<DashboardStatsDto> {
        return this.http.get<DashboardStatsDto>(`${this.apiUrl}/stats`);
    }
}
